import { useCallback, useEffect } from 'react';
import { useMessageBus } from './useMessageBus';
import { useCrmMessagingContext } from './CrmMessagingContext';
import { isCommandTopic } from './isCommandTopic';
import { throwCommandError } from './internal/throwCommandError';
import { useRegisterSender } from './MessageBusSpyContext';
export function useSendCrmMessageTopic(topic) {
  const messageBus = useMessageBus();
  const messagingContext = useCrmMessagingContext();
  const registerSender = useRegisterSender();
  useEffect(() => {
    if (isCommandTopic(topic) && !messageBus) {
      throwCommandError(`MessageBusError: The ${topic} command could not be sent because useSendCrmMessageTopic has no messageBus context.`);
    } else if (isCommandTopic(topic) && messageBus) {
      messageBus.registerCommandSender(topic, messagingContext);
    }

    // Register sender with spy context if available
    registerSender === null || registerSender === void 0 || registerSender(topic);
  }, [messageBus, topic, messagingContext, registerSender]);
  const messageContextId = messagingContext === null || messagingContext === void 0 ? void 0 : messagingContext.messagingId;
  return useCallback((data, config = {}) => {
    if (!messageBus) {
      return;
    }
    let enveloperSourceId;
    if (config.sourceId) {
      enveloperSourceId = config.sourceId;
    } else if (messageContextId) {
      enveloperSourceId = messageContextId;
    }
    const envelope = {
      sourceId: enveloperSourceId,
      targetId: config.targetId
    };
    const envelopeData = {
      envelope,
      data
    };
    messageBus.publish(topic, envelopeData);
  }, [messageBus, topic, messageContextId]);
}